import styled from 'styled-components';
import { PhotoCarouselNavControlsMixin } from '../../mixins/components/PhotoCarouselNavControlsMixin';
export var StyledPhotoCarouselNavControls = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPhotoCarouselNavControls",
  componentId: "c11n-8-111-1__sc-igi7la-0"
})(["", ""], PhotoCarouselNavControlsMixin);